<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailposttugasDosen', query: { post: check.post, class: check.class } }"
                exact>
                <v-icon left>mdi-book</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailtugaskumpulDosen', query: { post: check.post, class: check.class } }"
                exact>
                <v-icon left>mdi-checkbox-multiple-marked-outline</v-icon> Penilaian tugas
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-card flat>
                          <v-app-bar flat color="transparent" dense>
                            <v-toolbar-title class="font-weight-bold primary--text">
                              {{ detaildata[0].title_post }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-menu
                              v-if="false"
                              offset-y
                              bottom
                              left
                              nudge-bottom="10"
                              transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  color="primary"
                                  class="text-capitalize"
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  exact>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item>
                                  <v-list-item-title>Edit</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-app-bar>
                          <v-card-text class="pt-0">
                            <div>
                              {{ detaildata[0].user_firstname }} {{ detaildata[0].user_lastname }} - {{ detaildata[0].posted_at_post }}
                            </div>
                            <div class="font-weight-bold mb-3">
                              Batas pengumpulan: {{ detaildata[0].duedate_post }}
                            </div>
                            <div class="d-flex mb-3 text-center" v-if="infoansw">
                              <div class="d-inline px-3">
                                <span class="text-md-h4">
                                  {{ infoansw.submit ? infoansw.submit : 0 }}
                                </span><br>
                                <span>Sudah kumpul</span>
                              </div>
                              <div class="d-inline">
                                <v-divider vertical></v-divider>
                              </div>
                              <div class="d-inline px-3">
                                <span class="text-md-h4">
                                  {{ infoansw.total ? (infoansw.total - infoansw.submit) : 0 }}
                                </span><br>
                                <span>Belum kumpul</span>
                              </div>
                            </div>
                            <v-divider></v-divider>
                            <div class="my-3 content-editor" v-html="detaildata[0].desc_post"></div>
                            <div class="font-weight-bold">
                              Lampiran:
                            </div>
                            <div>
                              <v-tabs v-model="tabtugas">
                                <v-tab
                                  v-if="detaildata[0].url_post"
                                  class="text-capitalize"
                                  href="#tugas-video">
                                  Video
                                </v-tab>
                                <v-tab
                                  v-if="detaildata[0].file_post"
                                  class="text-capitalize"
                                  href="#tugas-file">
                                  File
                                </v-tab>
                              </v-tabs>
                              <v-tabs-items :touchless="true" v-model="tabtugas">
                                <v-tab-item
                                  v-if="detaildata[0].url_post"
                                  value="tugas-video">
                                  <v-card flat>
                                    <v-card-text>
                                      <vue-plyr>
                                        <div class="plyr__video-embed">
                                          <iframe
                                            :src="detaildata[0].url_post"
                                            allowfullscreen
                                            allowtransparency
                                            allow="autoplay">
                                          </iframe>
                                        </div>
                                      </vue-plyr>
                                    </v-card-text>
                                  </v-card>
                                </v-tab-item>
                                <v-tab-item
                                  v-if="detaildata[0].file_post"
                                  value="tugas-file">
                                  <v-card flat>
                                    <v-card-text>
                                      <a
                                        :href="detaildata[0].urlmateri"
                                        target="_blank">
                                        View attachment file
                                      </a>
                                      <iframe
                                        :src="getPdfView(detaildata[0].urlmateri)"
                                        style="width:100%; height:700px;"
                                        frameborder="0">
                                      </iframe>
                                    </v-card-text>
                                  </v-card>
                                </v-tab-item>
                              </v-tabs-items>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'DetailclassworkDosen', query: { class: check.class } }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Kembali ke kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getGdriveView } from '@/plugins/utils';
import { mapState } from 'vuex';

export default {
  name: 'DetailposttugasDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      teacher: false,
      student: false,
      getansw: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    teacherlist: [],
    studentlist: [],
    infoansw: null,
    panduan: null,
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      class: '',
      post: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    tabtugas: null,
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
      }
    },
    '$route.query.post'(val) {
      if (val) {
        this.check.post = val;
        this.getPost();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
    }
    if (this.$route.query.post && this.$route.query.post !== '') {
      this.check.post = this.$route.query.post;
      this.getPost();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    getPdfView(url) {
      return getGdriveView(url);
    },
    getPost() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class && this.check.post && this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/post/teacher/' + this.check.post + '/' + this.check.class,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.detaildata[0].urlmateri = this.api + '/upload/post/' + this.detaildata[0].file_post;
                this.getAnswerinfo();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Data tidak ditemukan!';
      }
    },
    getAnswerinfo() {
      this.loading.getansw = true;
      if (this.check.post && this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/answer/info/' + this.check.post + '/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const rd = res.data;
              // console.log(rd);
              this.infoansw = {
                submit: 0,
                total: 0,
              };
              if (rd.error === false) {
                this.infoansw = rd.data;
                // console.log(this.infoansw);
              }
            }
            this.loading.getansw = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getansw = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
